// extracted by mini-css-extract-plugin
export default {"success":"success_success__yIC8D","subheader":"success_subheader__RXiN7","subheader-item":"success_subheader-item__1o5L6"};